<template>
    <q-dialog ref="dialog" @hide="onDialogHide" persistent>
        <q-card class="q-dialog-plugin " style="width: 30vw; max-width: 90vw;">
            <q-toolbar class="bg-primary text-white">
                <q-toolbar-title v-text="(actionTitle + ' ' + screenTitle).trim()"></q-toolbar-title>
                <q-btn flat round dense icon="close" v-close-popup></q-btn>
            </q-toolbar>

            <q-form ref="modelForm">
                <q-card-section>
                    <div class="flex column wrap">
                        <div class="row q-col-gutter-lg">
                            <div class="col-12" >
                            <q-input v-model="model.Name" type="text" 
                                     label="Name *" 
                                     autofocus 
                                      maxlength="255"
                                      
                                     :rules="[val => val && val.length > 0 || 'Required',]"
                                     :error="fieldHasError('Name')"
                                     :error-message="fieldErrorMessage('Name')"
                                     
                                     
                                     dense>
                                
                                
                                
                            </q-input>
                        </div>
<div class="col-12" >
                            <q-input v-model="model.Code" type="text" 
                                     label="Code *" 
                                      
                                      maxlength="50"
                                      
                                     :rules="[val => val && val.length > 0 || 'Required',]"
                                     :error="fieldHasError('Code')"
                                     :error-message="fieldErrorMessage('Code')"
                                     
                                     
                                     dense>
                                
                                
                                
                            </q-input>
                        </div>
<div class="col-12" >
                            <q-select v-model="model.OrganizationType" 
                                      label="Organization Type *" 
                                       
                                       
                                      :options="dataSourceOrganizationType" option-value="Key" option-label="Value"
                                      emit-value map-options 
                                       
                                      :rules="[val => val==null ? !!val || 'Required' : true,]"
                                      :error="fieldHasError('OrganizationType')"
                                      :error-message="fieldErrorMessage('OrganizationType')"
                                      reactive-rules
                                      @input="onOrganizationTypeChange(model, ...arguments)"
                                      
                                      dense options-dense>
                                
                                
                                
                            </q-select>
                        </div>
<div class="col-12" v-show="model.OrganizationType === 1">
                            <q-select v-model="model.PartnerType" 
                                      label="Partner Type" 
                                       clearable clear-icon="close"
                                       
                                      :options="dataSourcePartnerType" option-value="Key" option-label="Value"
                                      emit-value map-options 
                                       
                                      :rules="[]"
                                      :error="fieldHasError('PartnerType')"
                                      :error-message="fieldErrorMessage('PartnerType')"
                                      
                                      @input="onPartnerTypeChange(model, ...arguments)"
                                      
                                      dense options-dense>
                                
                                
                                
                            </q-select>
                        </div>
<div class="col-12" >
                            <q-input v-model="model.CrmId" type="text" 
                                     label="CRM Id *" 
                                      
                                      maxlength="255"
                                      
                                     :rules="[val => val && val.length > 0 || 'Required',]"
                                     :error="fieldHasError('CrmId')"
                                     :error-message="fieldErrorMessage('CrmId')"
                                     
                                     
                                     dense>
                                
                                
                                
                            </q-input>
                        </div>
<div class="col-12" >
                            <q-input v-model="model.BillingId" type="text" 
                                     label="Billing Id *" 
                                      
                                      maxlength="255"
                                      
                                     :rules="[val => val && val.length > 0 || 'Required',]"
                                     :error="fieldHasError('BillingId')"
                                     :error-message="fieldErrorMessage('BillingId')"
                                     
                                     
                                     dense>
                                
                                
                                
                            </q-input>
                        </div>
<div class="col-12" >
                            <q-input v-model="model.SupportId" type="text" 
                                     label="Support Id *" 
                                      
                                      maxlength="255"
                                      
                                     :rules="[val => val && val.length > 0 || 'Required',]"
                                     :error="fieldHasError('SupportId')"
                                     :error-message="fieldErrorMessage('SupportId')"
                                     
                                     
                                     dense>
                                
                                
                                
                            </q-input>
                        </div>
<div class="col-12" >
                            <q-input v-model="model.CompanyDomain" type="text" 
                                     label="Company Domain *" 
                                      
                                      maxlength="255"
                                      
                                     :rules="[val => val && val.length > 0 || 'Required',]"
                                     :error="fieldHasError('CompanyDomain')"
                                     :error-message="fieldErrorMessage('CompanyDomain')"
                                     
                                     
                                     dense>
                                
                                
                                
                            </q-input>
                        </div>
<div class="col-12" v-show="model.Id > 0">
                            <q-checkbox v-model="model.IsActive" 
                                        label="Active" 
                                         
                                        
                                        
                                        dense>
                                
                                
                            </q-checkbox>
                        </div>
<div class="col-12" >
                            <q-checkbox v-model="model.SkipIdValidation" 
                                        label="Skip Id Validation" 
                                         
                                        
                                        
                                        dense>
                                
                                
                            </q-checkbox>
                        </div>

                        </div>
                    </div>
                </q-card-section>
            </q-form>

            <q-toolbar>
                <div class="q-gutter-xs">
                    
                </div>

                <q-space></q-space>

                <div class="q-gutter-xs" v-if="editMode === true">
                    
                    <q-btn color="primary" :label="actionLabel" @click="onOkClick" :disable="actionLocked"></q-btn>
                    <q-btn color="white" text-color="black" label="Cancel" @click="onCancelClick" :disable="actionLocked"></q-btn>
                </div>
                <div class="q-gutter-xs" v-if="editMode === false">
                    
                    <q-btn color="white" text-color="black" label="Close" @click="onCancelClick" :disable="actionLocked"></q-btn>
                </div>
            </q-toolbar>

            <q-inner-loading :showing="loading">
                <q-spinner-gears size="50px" color="primary"></q-spinner-gears>
            </q-inner-loading>
        </q-card>
    </q-dialog>
</template>

<style>
    
</style>

<script>
    export { default } from './organizationaddeditmodel-dialog-screen.js'
</script>